export default __webpack_public_path__ + "static/media/yusuf.1e2ad6f0.webp";